import axios from 'axios';


/*

{
	"success": true,
	"data": {
		"id": "6a236de0-81b0-4d5e-b0ac-3988bed1c392",
		"name": "Link de Pagamento Drip",
		"status": "created",
		"isActive": true,
		"clientId": "4c7bbf92-2fa2-4044-b7a2-448d93b09b57",
		"orderId": null,
		"amount": 57480,
		"currency": "BRL",
		"capture": null,
		"merchantId": "797670bd-28ad-4036-806c-2464f394412a",
		"dueDate": "2025-06-27T18:19:05.474Z",
		"description": null,
		"statementDescriptor": null,
		"items": [
			{
				"name": "Pro vitalicio",
				"description": null,
				"unitPrice": 57480,
				"quantity": 1,
				"tangible": true,
				"categoryId": null
			}
		],
		"paymentLink": "",
		"paymentMethods": [
			{
				"paymentType": "drip",
				"successRedirectUrl": null,
				"cancelRedirectUrl": null
			}
		],
		"createdAt": "2025-06-26T18:19:06.000Z",
		"updatedAt": "2025-06-26T18:19:06.000Z",
		"publicKey": "6f41acb1-4c22-4fed-a79d-3d34bb7e0d3b"
	}
}
*/

export interface PaymentItem {
  name: string;
  description: string | null;
  unitPrice: number;
  quantity: number;
  tangible: boolean;
  categoryId: string | null;
}

export interface PaymentMethod {
  paymentType: string;
  successRedirectUrl: string | null;
  cancelRedirectUrl: string | null;
}

export interface PaymentData {
  id: string;
  name: string;
  status: string;
  isActive: boolean;
  clientId: string;
  orderId: string | null;
  amount: number;
  currency: string;
  capture: boolean | null;
  merchantId: string;
  dueDate: string;
  description: string | null;
  statementDescriptor: string | null;
  items: PaymentItem[];
  paymentLink: string;
  paymentMethods: PaymentMethod[];
  createdAt: string;
  updatedAt: string;
  publicKey: string;
}

export interface PaymentResponse {
  success: boolean;
  data: PaymentData;
}
export async function sendPaymentRequest(
  product: string
): Promise<PaymentResponse> {
  try {
    const endpoint = 'https://pix-parcelado.dio.me';
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axios.post(endpoint, {product}, {
      headers: headers
    });
    return response.data;
  } catch (error) {
    throw error;
  }
}